export default (function () { });
//# sourceMappingURL=noop.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/noop.js
// module id = 511
// module chunks = 3